import urlParser from '../urlParser';

const generatePromotionCardBlock = (title, date, imageUrl, bookLink) => {
	const template = document.querySelector('._template-block > .card-block').cloneNode(true);

	template.lastChild.lastChild.innerText = title;
	template.lastChild.firstChild.innerText = date;
	template.firstChild.setAttribute(
		'style',
		`background-image: url(${imageUrl})`,
	);

	if (bookLink) {
		template.querySelector('.content').innerHTML += `<a href='${bookLink}' class='book-button'>${{
			tw: '預訂',
			en: 'BOOK',
			cn: '预订',
			jp: '予約',
		}[urlParser.language]}</a>`;
	}

	return template;
};

export default generatePromotionCardBlock;



// WEBPACK FOOTER //
// ./src/js/promotion/generatePromotionCardBlock.js